import clsx from 'clsx';
import { TApplication } from 'lendingApi/applications.types';
import { PRIVACY_DISPLAY_CLASSES } from 'utils/privacyClasses';
import styles from './ApplicantCell.module.css';

type TProps = {
  customer: TApplication['customer'];
};

export const ApplicantCell = ({ customer }: TProps) => {
  return (
    <div
      className={clsx(styles.applicant, PRIVACY_DISPLAY_CLASSES)}
      data-testid="applicant-cell"
    >
      {[customer?.first_name, customer?.last_name].filter(Boolean).join(' ')}
    </div>
  );
};
